import { type Component, createSignal, onMount, Show } from "solid-js"
import { AppRoutes } from "../../shared/app-routes"
import { useTracking } from "../../shared/providers/tracking.provider"
import Footer from "../shared/components/Footer"
import WebinarHeadlineB from "./WebinarHeadlineB"
import WebinarOfferingBoxB from "./WebinarOfferingBoxB"
import EmailDisclaimerDialog from "../shared/components/EmailDisclaimerDialog"
import CheckoutUnavailableDialog from "../shared/components/CheckoutUnavailableDialog"
import SimpleTopBar from "../thanks/SimpleTopBar"
import { useWebinarCheckout } from "../shared/use-webinar-checkout"

const WebinarB: Component = () => {
  const { setVariant, trackOfferCtaClicked } = useTracking()
  const [showDisclaimer, setShowDisclaimer] = createSignal(false)

  onMount(() => {
    setVariant("peak")
  })

  const { product, showCheckout, checkoutUnavailable, markCheckoutUnavailable } =
    useWebinarCheckout(AppRoutes.WebinarB)

  const attemptToPurchase = (): void => {
    trackOfferCtaClicked(product)
    if (!product) {
      markCheckoutUnavailable()
      return
    }
    setShowDisclaimer(true)
  }

  return (
    <div class='relative flex flex-col'>
      <Show when={showDisclaimer()}>
        <EmailDisclaimerDialog
          confirm={() => {
            setShowDisclaimer(false)
            void showCheckout()
          }}
        />
      </Show>
      <Show when={checkoutUnavailable()}>
        <CheckoutUnavailableDialog />
      </Show>
      <div class='min-h-screen flex flex-col' style="background: radial-gradient(44.49% 44.49% at 50% 55.51%, #213943 0%, #15262D 100%)">
        <SimpleTopBar />
        <div class='flex-1 flex items-center w-full'>
          <div class='flex flex-col xl:flex-row w-full max-w-[1280px] mx-auto gap-10 px-4 sm:px-10 lg:px-20 py-10'>
            <div class='w-full xl:flex-1 xl:min-w-0'>
              <WebinarHeadlineB showCheckout={attemptToPurchase} />
            </div>
            <div class='w-full xl:flex-1 xl:min-w-0 flex justify-center items-center'>
              <WebinarOfferingBoxB showCheckout={attemptToPurchase} offeringPrice={300} showButton={true} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default WebinarB
